<template>
  <div id="booking">
    <section id="booking-intro">
      <slot name="top">
        <p class="text-center mt-5" v-if="bookingForm.travel">
          Schön, dass du dich für
          <span class="fs-3">{{ bookingForm.travel.destination }}</span>
          entschieden hast.
        </p>
        <p class="text-center fs-3 fw-bold" v-if="bookingForm.travel">
          {{ bookingForm.travel_date.timespan }}
        </p>
      </slot>
    </section>
    <section>
      <div class="container container-booking">
        <div class="card border-0 rounded-0">
          <div class="booking-section">
            <div class="booking-inner">
              <div class="card-body">
                <booking-nav v-if="nav" />
                <div class="position-relative">
                  <slot />
                  <div
                    v-if="store.loading"
                    class="position-absolute top-0 start-0 bg-white w-100 h-100 d-flex justify-content-center align-items-center opacity-75"
                  >
                    <spinner />
                  </div>
                </div>
              </div>

              <div class="card-footer bg-white border-0" v-if="step < 4">
                <slot name="footer">
                  <div class="row py-2">
                    <div class="col">
                      <btn-back @click="onBack" v-if="step > 1 && step < 4" />
                    </div>
                    <div class="col text-end">
                      <btn-next
                        :variant="btnNextVariant"
                        @click="onNext"
                        v-if="step < 4"
                        ><template v-if="btnNextTitle">{{
                          btnNextTitle
                        }}</template></btn-next
                      >
                    </div>
                  </div>
                </slot>
              </div>
            </div>
            <!-- <booking-login /> -->
          </div>
        </div>
      </div>
    </section>
    <slot name="bottom"></slot>
  </div>
</template>
<script setup>
import { computed, inject, onBeforeMount, reactive } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";
import BookingNav from "./Nav";
import BookingLogin from "./Login";
import BtnBack from "./BtnBack";
import BtnNext from "./BtnNext";
import { Inertia } from "@inertiajs/inertia";
import { store } from "../../store";
import Spinner from "../../Components/Scol/Spinner";
const route = inject("route");
const session = inject("session");
const emit = defineEmits(["onBack", "onNext"]);
const bookingForm = computed(() => usePage().props.value.bookingForm);
const loading = computed(() => usePage().props.loading);
const step = computed(() => bookingForm.value.step_current.no);
const props = defineProps({
  nav: {
    type: Boolean,
    default: true,
  },
});
const btnNextTitle = computed(() =>
  _.get(bookingForm.value.step_current, "btn.next.title")
);
const btnNextVariant = computed(() =>
  _.get(bookingForm.value.step_current, "btn.next.variant")
);
function onBack() {
  store.loading = true;
  let data = {
    travelDate: bookingForm.value.travel_date.slug,
    t: sessionStorage.getItem("tab_id"),
  };
  if (step.value == 2) {
    data.tid = bookingForm.value.travel.id;
    data.tdid = bookingForm.value.travel_date.id;
  }
  Inertia.visit(route(bookingForm.value.step_back.route_name, data), {
    onFinish: () => (store.loading = false),
  });
  emit("onBack");
}
function onNext() {
  store.loading = true;
  emit("onNext");
}
onBeforeMount(() => {
  // console.log('START :: RELOAD');
  session.inertiaReload();
  // console.log('STOP :: RELOAD');
});
</script>
